export const userStatusValues = {
  CANCELED: 'CANCELED',
  PENDING: 'PENDING',
  VALIDATED: 'VALIDATED',
} as const;
export type TUserStatus = keyof typeof userStatusValues;

export const parentTypeValues = {
  EMPLOYEE: 'employee',
  LEADER: 'leader',
  SHAREHOLDER: 'shareholder',
} as const;
export type TParentType = keyof typeof parentTypeValues;

export const titleValues = { M: 'M', MLLE: 'MLLE', MME: 'MME' } as const;
export type TTitle = keyof typeof titleValues;

export const distributionCountryValues = {
  BE: 'BE',
  DE: 'DE',
  ES: 'ES',
  FR: 'FR',
  IT: 'IT',
  NL: 'NL',
} as const;
export type TDistributionCountry = keyof typeof distributionCountryValues;

export const occupationTypeValues = {
  PRIVATE_SECTOR_EMPLOYEES: 'private_sector_employees',
  PUBLIC_SECTOR_EMPLOYEES: 'public_sector_employees',
  RETIRED_PEOPLE_AND_STUDENTS: 'retired_people_and_students',
  SELF_EMPLOYED: 'self_employed',
  WITHOUT_ANY_PROFESSIONAL_ACTIVITY: 'without_any_professional_activity',
} as const;
export type TOccupationType = keyof typeof occupationTypeValues;

export const sourceOfFundsValues = {
  DONATION: 'donation',
  INHERITANCE: 'inheritance',
  LOAN: 'loan',
  LOTTERY: 'lottery',
  PENSION: 'pension',
  PROCEEDS_FROM_INVESTMENT: 'proceeds_from_investment',
  PROCEEDS_FROM_SALE: 'proceeds_from_sale',
  SALARY: 'salary',
  SAVINGS: 'savings',
} as const;
export type TSourceOfFunds = keyof typeof sourceOfFundsValues;

export const legalSectorTypeValues = { NACE: 'NACE', NAF: 'NAF' } as const;
export type TLegalSectorType = keyof typeof legalSectorTypeValues;

export interface IUser {
  userId: number;
  userStatus?: TUserStatus;
  userTag?: string;
  parentUserId?: number;
  parentType?: TParentType;
  controllingPersonType?: number;
  employeeType?: number;
  specifiedUSPerson?: number;
  title?: TTitle;
  firstname?: string;
  lastname?: string;
  middleNames?: string;
  birthday?: string;
  email?: string;
  address1?: string;
  address2?: string;
  address3?: string;
  postcode?: string;
  city?: string;
  state?: string;
  country?: string;
  countryName?: string;
  distributionCountry?: TDistributionCountry;
  secondaryAddress1?: string;
  secondaryAddress2?: string;
  secondaryAddress3?: string;
  secondaryPostcode?: string;
  secondaryCity?: string;
  secondaryState?: string;
  secondaryCountry?: string;
  phone?: string;
  mobile?: string;
  nationality?: string;
  nationalityOther?: string;
  placeOfBirth?: string;
  birthCountry?: string;
  occupation?: string;
  incomeRange?: string;
  legalName?: string;
  legalNameEmbossed?: string;
  legalRegistrationNumber?: string;
  legalTvaNumber?: string;
  legalRegistrationDate?: string;
  legalForm?: string;
  legalShareCapital?: number;
  legalSector?: string;
  legalAnnualTurnOver?: string;
  legalNetIncomeRange?: string;
  legalNumberOfEmployeeRange?: string;
  effectiveBeneficiary?: number;
  kycLevel?: number;
  kycReview?: number;
  kycReviewComment?: string;
  isFreezed?: number;
  isFrozen?: number;
  language?: string;
  optInMailing?: number;
  sepaCreditorIdentifier?: string;
  taxNumber?: string;
  taxResidence?: string;
  position?: string;
  personalAssets?: string;
  activityOutsideEu?: number;
  economicSanctions?: number;
  residentCountriesSanctions?: number;
  involvedSanctions?: number;
  entitySanctionsQuestionnaire?: number;
  sanctionsQuestionnaireDate?: string;
  timezone?: string;
  occupationType?: TOccupationType;
  sourceOfFunds?: TSourceOfFunds;
  legalSectorType?: TLegalSectorType;
  isOnStockExchange?: number;
  codeStatus?: string;
  informationStatus?: string;
  createdDate?: string;
  modifiedDate?: string;
  walletCount?: number;
  payinCount?: number;
  totalRows?: number;
  occupationCategory?: number;
  personalAssetsRange?: number;
  monthlyIncomeRange?: number;
}
